import { useConsult } from 'contexts/ConsultContext';

/**
 * Hook that determines if the patient is NP referral and needs to do onboarding
 * @returns boolean indicating if the patient is NP referral
 */
export const useNpReferral = (): boolean => {
  const consultContext = useConsult();
  return !!consultContext.consult?.patient.unfinishedNpOnboarding;
};
